export default __webpack_public_path__ + "static/media/edital_complementar.5c15b5a1.pdf";